
import { mapGetters } from 'vuex';
import i18n from '@/lib/i18n';

export default {
  name: 'DesignContentLayout',
  computed: {
    ...mapGetters('menu', ['selectedMainMenuItem', 'selectedSubMenuItem']),
    description() {
      return i18n.t(`menu.description.${this.selectedSubMenuItem.id}`);
    }
  }
};
